import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function softDeleteCLesson(clessonId: any) {
    const { apiPostSoftDeleteCLesson } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostSoftDeleteCLesson}${clessonId}/`);
}
